import React, { useState } from 'react';
import { Typography, Button } from 'antd';
import { ItineraryItem } from '@common-types';
import './style.scss';

const { Title, Text } = Typography;

interface ItineraryProps {
    items: ItineraryItem[];
}

export const Itinerary: React.FC<ItineraryProps> = ({ items }) => {
    const [expandedItems, setExpandedItems] = useState<{ [key: number]: boolean }>({});

    const toggleExpand = (index: number) => {
        setExpandedItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    if (!items || items.length === 0) return null;

    return (
        <div className="activity-itinerary">
            <div className="itinerary-timeline">
                {items.map((item, index) => {
                    const isPassBy = item.name.toLowerCase().includes('(pass by)');
                    const isExpanded = expandedItems[index];
                    const description = item.description || '';
                    const shouldShowReadMore = description.length > 200;
                    const displayDescription = isExpanded || !shouldShowReadMore
                        ? description
                        : `${description.substring(0, 200)}...`;

                    return (
                        <div key={index} className="itinerary-item">
                            <div className="itinerary-left">
                                {isPassBy ? (
                                    <div className="itinerary-dot" />
                                ) : (
                                    <div className="itinerary-number">{item.order || index + 1}</div>
                                )}
                                {index < items.length - 1 && <div className="itinerary-line" />}
                            </div>
                            <div className="itinerary-content">
                                <Title level={4} className="itinerary-title">
                                    {item.name}
                                </Title>
                                <div className="itinerary-description">
                                    <Text>
                                        {displayDescription}
                                        {shouldShowReadMore && (
                                            <Button
                                                type="link"
                                                onClick={() => toggleExpand(index)}
                                                className="read-more-btn"
                                            >
                                                {isExpanded ? 'Read less' : 'Read more'}
                                            </Button>
                                        )}
                                    </Text>
                                </div>
                                <div className="itinerary-meta">
                                    {item.formattedDuration && (
                                        <Text type="secondary" className="meta-info">
                                            {item.formattedDuration}
                                        </Text>
                                    )}
                             
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
